import * as React from 'react';

import { usePageContext } from '../../providers/PageContext';

const regionalForms = {
  latam: React.lazy(() => import('./ContactFormLatam')),
  apac: React.lazy(() => import('./ContactFormApac')),
  emea: React.lazy(() => import('./ContactFormEmea')),
};

const ckForms = {
  blockContactSliceForm: React.lazy(() => import('./AncientDivForm')),
  defaultForm: React.lazy(() => import('./AncientDivForm')),
};

interface FormResolverProps {
  caller?: 'BlockContactSlice' | 'BlockHeroFormSlice';
  color?: 'primary' | 'secondary' | 'tertiary';
  buttonText?: string;
  form_title?: string;
  formVariant?: string;
}

/** Handles which form to render based on site and block */
const FormResolver: React.FunctionComponent<FormResolverProps> = ({
  caller,
  buttonText = 'Submit',
  form_title = false,
  formVariant = 'default',
}) => {
  const pageContext = usePageContext();
  const { siteTag, siteRegion } = pageContext;

  if (siteTag === 'site:kitchenpark' || siteTag === 'site:smartinfra') {
    return null;
  }

  if (siteTag !== 'site:cloudkitchens') {
    const ContactForm = regionalForms[siteRegion];
    if (!ContactForm)
      throw new Error(
        'Failed to resolve intl contact form, check FormResolver.tsx'
      );
    return (
      <ContactForm
        textColor={caller === 'BlockHeroFormSlice' ? 'white' : 'grey'}
        siteTag={siteTag}
        formVariant={formVariant}
      />
    );
  }

  // TODO: BlockContactSliceForm and AncientDivForm should probably be merged into just one form
  const ContactForm = ckForms.defaultForm;
  const formColor = caller === 'BlockHeroFormSlice' ? 'white' : 'grey';

  return (
    <ContactForm
      buttonText={buttonText}
      color={formColor}
      form_title={form_title}
      formVariant={formVariant}
    />
  );
};

export default FormResolver;
